export default {
    programs: {
        create: {
            title: 'Create  New Program',
            subtitle: 'Email Templates',
            successMessage: 'New Program has been added',
            addEmailButton: 'Add New Email',
            addEmailButtonMobile: 'Add Email'
        },
        edit: {
            title: 'Edit Program',
            subtitle: 'Email Templates',
            successMessage: 'New Program has been updated'
        },
        list: {
            title: 'Programs',
            createButton: 'add new program',
            createButtonMobile: 'add',
            deleteSuccessMessage: 'The program has been deleted'
        },
        tableHeaders: [
            { text: 'Program Title', value: 'title' },
            { text: 'Meditations', value: 'meditationsTotal', sortable: false },
            { text: 'Controls', class: 'actions', sortable: false }
        ],
        mobile: {
            sort: {
                name: 'Program Title',
                meditationsTotal: 'Meditations Total'
            }
        },
        email: {
            createTitle: 'Create email',
            editTitle: 'Edit email'
        }
    }
};
